module.exports = __webpack_public_path__ + "img/overheads-telephone-and-internet.e473df10.svg";